<div class="mainContainer d-flex flex-column align-items-center mb-4">
  <h2 class="headingBL text-center mb-4">Express <span>Curiosity</span></h2>
  <div class="d-flex flex-column gap-3 cardsWrap">
    <div
      class="d-flex flex-row align-items-center gap-4 cards"
      *ngFor="let curiosity of curiosity"
    >
      <img
        loading="lazy"
        class="img"
        [src]="curiosity.image" 
        alt="Legend Icon"
      />
      <div class="d-flex flex-column gap-3 text_wrapper">
        <h4 class="headingBL head">
          {{ curiosity.heading1 }}<span>{{ curiosity.heading2 }}</span>
        </h4>
        <p class="vtext1 details">
          {{ curiosity.details }}
        </p>
        <div class="btnGlobal--primary" routerLink="/form/{{curiosity.name}}">Join Virsa</div>
      </div>
    </div>
  </div>
</div>
